var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegrity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143.71 115.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#505050;}.cls-2{fill:#9ca5ad;}.cls-3{stroke:#505050;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.81,6.76A20.15,20.15,0,0,0,72.66,26.91,20.15,20.15,0,0,0,52.51,6.76H0v93.81H52.51a20.15,20.15,0,0,1,19.42,14.79h1.46a20.14,20.14,0,0,1,19.42-14.79h50.9V6.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.63,0H11.29V89.17H54.63c5.43,0,15.42,2.51,18,13.15V18A18,18,0,0,0,54.63,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.68,0h42.54V89.17H90.68c-5.43,0-15.41,2.51-18,13.15V18A18,18,0,0,1,90.68,0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 72.66,
    y1: 26.92,
    x2: 72.66,
    y2: 81.98
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrity);
export default __webpack_public_path__ + "static/media/integrity.14a30822c2af59ba6c72e045cd839c83.svg";
export { ForwardRef as ReactComponent };